import { render, staticRenderFns } from "./HeaderNotifications.vue?vue&type=template&id=8c97404a&"
import script from "./HeaderNotifications.vue?vue&type=script&lang=js&"
export * from "./HeaderNotifications.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNotifications.vue?vue&type=style&index=0&id=8c97404a&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c97404a')) {
      api.createRecord('8c97404a', component.options)
    } else {
      api.reload('8c97404a', component.options)
    }
    module.hot.accept("./HeaderNotifications.vue?vue&type=template&id=8c97404a&", function () {
      api.rerender('8c97404a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HeaderNotifications.vue"
export default component.exports